import type { ReactNode } from 'react'
import { cn } from 'utils/cn'

/** A Box Truck vehicle form section: a card on the full forms, flat under a divider in Quick Add Truck, as Quick Add Driver lays out its own. */
export const boxTruckSectionClass = (bare: boolean): string =>
    bare ? 'space-y-4 border-t border-border pt-4' : 'space-y-4 rounded-2xl bg-surface p-5 shadow-surface'

interface BoxTruckSectionHeadingProps {
    bare: boolean
    className?: string
    children: ReactNode
}

export const BoxTruckSectionHeading = ({ bare, className, children }: BoxTruckSectionHeadingProps) =>
    bare ? (
        <h4 className={cn(className, 'text-sm font-semibold text-foreground')}>{children}</h4>
    ) : (
        <h3 className={cn(className, 'text-base font-semibold text-foreground')}>{children}</h3>
    )
